@if (expiredToken) {
  <section class="no-auth-page centered">
    <div class="icon"><i class="fa-solid fa-circle-exclamation"></i></div>
    <p>{{ 'shared.oneTimeLogin.linkExpired' | translate }}</p>
    <button
      ht-button-primary
      appearance="minimal"
      [fullWidth]="true"
      routerLink="/reset-pwd"
    >
      {{ 'shared.oneTimeLogin.tryResetAgain' | translate }}
    </button>
  </section>
}
